"use client";

import { useEffect, useState } from "react";

export default function HeroVideo() {
  const [shouldRenderVideo, setShouldRenderVideo] = useState(false);

  useEffect(() => {
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

    if (!isDesktop) {
      return;
    }

    const idle = window.setTimeout(() => {
      setShouldRenderVideo(true);
    }, 1200);

    return () => {
      window.clearTimeout(idle);
    };
  }, []);

  if (!shouldRenderVideo) {
    return null;
  }

  return (
    <video
      autoPlay
      loop
      muted
      playsInline
      preload="none"
      poster="/video-thumbnail.jpg"
      className="object-cover w-full h-full grayscale-[20%] brightness-[0.6]"
    >
      <source src="/1herovideo.mp4" type="video/mp4" />
    </video>
  );
}
